import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class ScenarioCriteria extends BasicCriteria {
scenariiCodes: string[];
stepLevels: number[];
visionCode: string;
visionCodeList: string[];
}

